var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 494.4 494.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3EFFF"
    },
    d: "M32.8,476.8c0-118.4,96-214.4,214.4-214.4s214.4,96,214.4,214.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC6C15"
    },
    d: "M283.2,370.4c0,108-16,68-36,68s-36,40.8-36-68s16-196,36-196S283.2,262.4,283.2,370.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M223.2,0c26.4,0,48,36,48,80.8s-21.6,80.8-48,80.8V1.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AA06E"
    },
    d: "M271.2,80.8c0,44.8-21.6,80.8-48,80.8V48.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M127.2,61.6c19.2-19.2,60-8.8,91.2,23.2c32,32,42.4,72.8,23.2,91.2L128.8,64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AA06E"
    },
    d: "M218.4,84.8c32,32,42.4,72.8,23.2,91.2l-80-80"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M89.6,184c0-26.4,36-48,80.8-48s80.8,21.6,80.8,48h-160"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AA06E"
    },
    d: "M171.2,136c44.8,0,80.8,21.6,80.8,48H139.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M155.2,316c-22.4-14.4-21.6-56.8,2.4-94.4s61.6-56.8,84-42.4L156,313.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AA06E"
    },
    d: "M157.6,221.6c24-37.6,61.6-56.8,84-42.4l-60,95.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M367.2,61.6c-19.2-19.2-60-8.8-91.2,23.2c-32,32-42.4,72.8-23.2,91.2L365.6,64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AA06E"
    },
    d: "M276,84.8c-32,32-42.4,72.8-23.2,91.2l80-80"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M404.8,184c0-26.4-36-48-80.8-48s-80.8,21.6-80.8,48h160"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AA06E"
    },
    d: "M323.2,136c-44.8,0-80.8,21.6-80.8,48h112.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M339.2,316c22.4-14.4,21.6-56.8-2.4-94.4s-61.6-56.8-84-42.4l85.6,135.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AA06E"
    },
    d: "M336.8,221.6c-24-37.6-61.6-56.8-84-42.4l60,95.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965011"
    },
    d: "M247.2,174.4c20,0,36,88,36,196s-16,68-36,68"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC114"
    },
    d: "M487.2,494.4c-62.4-59.2-147.2-95.2-240-95.2s-177.6,36-240,95.2H487.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA12A"
    },
    d: "M314.4,494.4h172.8c-62.4-59.2-147.2-95.2-240-95.2"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC114"
    },
    cx: 217.6,
    cy: 200,
    r: 29.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A15"
    },
    d: "M238.4,179.2c11.2,11.2,11.2,30.4,0,41.6c-11.2,11.2-30.4,11.2-41.6,0"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC114"
    },
    cx: 276.8,
    cy: 200,
    r: 29.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A15"
    },
    d: "M297.6,179.2c11.2,11.2,11.2,30.4,0,41.6c-11.2,11.2-30.4,11.2-41.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC114"
    },
    d: "M268,127.2c11.2,11.2,11.2,30.4,0,41.6c-11.2,11.2-30.4,11.2-41.6,0c-11.2-11.2-11.2-30.4,0-41.6 C237.6,116,256.8,116,268,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A15"
    },
    d: "M247.2,119.2c16,0,29.6,13.6,29.6,29.6s-13.6,29.6-29.6,29.6"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.87bdecf6491df331e425c5d65dac8a4c.svg";
export { ForwardRef as ReactComponent };